import {values} from 'lodash';

const internalOrgs: Record<string, string> = Object.freeze({
  AUTOMATION: '1630cefc-c0d9-4819-b878-99b3dcefca09',
  CA_CENTRAL: '08175cf0-d3e2-4458-48f9-11a593a620f2',
  CANADA: '4046224d-32e0-4d72-be7a-218b8079de51',
  DCA_TESTBED: '686a33ec-88b9-4f84-bddf-2a1fb0fecb85',
  E2E_TEST: 'b3dcfe21-1673-484f-ac7d-72e5e9e78e75',
  EU_CENTRAL: 'c555fc43-2b6a-4b8e-94a9-9bd4802682b1',
  R7_US: '69913888-6eb3-4160-a138-92d60cb40d72',
  R7E2E_01: '5f446436-2e85-4b86-85bc-a3fa2d8f4845',
  STAGING: '0c5ed550-34ec-42e8-8207-27ac424e1e4e',
  SYDNEY: 'e43ee83b-4f28-4f1c-8c30-1f4e134772a7',
  US_EAST_1: '67979719-601d-4b04-b7d1-a445189ddd1e',
});

export default values(internalOrgs);
